"use strict";
const sideNavigationSelect = '.js-backend_mobile_side_navigation_select';
window.up.compiler(sideNavigationSelect, function (select) {
    const previousValue = select.value;
    window.up.on(select, 'change', undefined, () => {
        if (select.value === '#cello') {
            select.value = previousValue;
        }
        else {
            const selectedOption = select.selectedOptions[0];
            if (selectedOption) {
                const navigateOptions = { url: select.value };
                if (selectedOption.hasAttribute('data-disable-unpoly-link-cache')) {
                    Object.assign(navigateOptions, { cache: false });
                }
                window.up.navigate('.unpoly_wrapper', navigateOptions);
            }
        }
    });
});
